// EmptyData 는 shared/ui 로 이관됨. 하위호환 re-export.
export { EmptyData } from '@/shared/ui'
